import { Dashboard } from "./types";
import fetchWrapper from "src/utils/fetchWrapper";
import { AuthSelectors } from "src/redux/Auth/selectors";

export const DashboardActions = {
    /**
     * Fetch trading activity summary from trade-monitor.
     * The auth-gateway routes /trade-monitor/* and sets X-Auth-Cpty-Code
     * from the JWT, so the backend scopes the data automatically.
     */
    FetchSummary: (from, to) => {
        return async (dispatch, getState) => {
            dispatch({ type: Dashboard.SET_LOADING, loading: true });
            try {
                const url = AuthSelectors.BuildTradeMonitorSummaryUrl(getState(), from, to);
                const summary = await dispatch(fetchWrapper(url));
                dispatch({ type: Dashboard.SET_SUMMARY, summary });
            } catch (error) {
                console.error("Failed to fetch dashboard summary:", error);
                dispatch({ type: Dashboard.SET_ERROR, error: error.message });
            } finally {
                dispatch({ type: Dashboard.SET_LOADING, loading: false });
            }
        };
    },

    /**
     * Fetch market breakdown from trade-monitor.
     */
    FetchMarketBreakdown: (from, to) => {
        return async (dispatch, getState) => {
            try {
                const url = AuthSelectors.BuildTradeMonitorMarketBreakdownUrl(getState(), from, to);
                const marketBreakdown = await dispatch(fetchWrapper(url));
                dispatch({ type: Dashboard.SET_MARKET_BREAKDOWN, marketBreakdown });
            } catch (error) {
                console.error("Failed to fetch market breakdown:", error);
                dispatch({ type: Dashboard.SET_ERROR, error: error.message });
            }
        };
    },

    /**
     * Fetch both summary and market breakdown.
     */
    FetchAll: (from, to) => {
        return async (dispatch) => {
            await Promise.all([
                dispatch(DashboardActions.FetchSummary(from, to)),
                dispatch(DashboardActions.FetchMarketBreakdown(from, to)),
            ]);
        };
    },
};
